import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconFullscreenStyle0 = gravityIconIndividualCss;

const GravityIconFullscreen = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '2baaf9278fcae7d0da262d79bad68d7e72fd8f86', color: this.color, size: this.size }, h("svg", { key: '502a05a0d31101f96cd4a20b3148779667609dd2', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'b6e8132772cd269f5334bf5d14b5593832586fd8', d: "M3.5 5.5v3A.5.5 0 0 1 3 9h-.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5h-5Zm15 0h-5A.5.5 0 0 1 13 5v-.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H19a.5.5 0 0 1-.5-.5v-3Zm0 8v3h-5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5H19a.5.5 0 0 0-.5.5Zm-15 3h5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5H3a.5.5 0 0 1 .5.5v3Z", fill: "currentColor" }))));
    }
};
GravityIconFullscreen.style = GravityIconFullscreenStyle0;

export { GravityIconFullscreen as gravity_icon_fullscreen };

//# sourceMappingURL=gravity-icon-fullscreen.entry.js.map